import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiImage, FiCompass } = FiIcons;

const galleryItems = [
  {
    src: 'https://cloud.sharemyimage.com/2026/10/09/Pepito_HermitCrab1.jpg',
    alt: 'Pepito the Hermit Crab original book artwork',
    book: 'pepito',
    label: 'Pepito the Hermit Crab'
  },
  {
    src: 'https://cloud.sharemyimage.com/2026/10/09/PepitoHermitCrab_bldg.png',
    alt: 'Pepito the Hermit Crab exploring tall buildings',
    book: 'pepito',
    label: 'Pepito & The City'
  },
  {
    src: 'https://cloud.sharemyimage.com/2026/10/09/PepitoHermitCrab_exclamation.png',
    alt: 'Pepito the Hermit Crab with surprise exclamation',
    book: 'pepito',
    label: 'Curious Pepito'
  },
  {
    src: 'https://cloud.sharemyimage.com/2026/10/09/PepitoHermitCrab_pipes.png',
    alt: 'Pepito the Hermit Crab near pipes and underground pathways',
    book: 'pepito',
    label: 'Pipe Explorations'
  },
  {
    src: 'https://cloud.sharemyimage.com/2026/10/09/PepitoHermitCrab_bricks.png',
    alt: 'Pepito the Hermit Crab clambering along brick walls',
    book: 'pepito',
    label: 'The Brick Adventure'
  },
  {
    src: 'https://cloud.sharemyimage.com/2026/10/08/Binjamin_Color_1.png',
    alt: 'Colorful Binjamin the Dumpster illustration',
    book: 'binjamin',
    label: 'Binjamin Full Color'
  },
  {
    src: 'https://cloud.sharemyimage.com/2026/10/08/Binjamin_Dumpster_grafitti.png',
    alt: 'Binjamin the Dumpster graffiti artwork',
    book: 'binjamin',
    label: 'Alleyway Graffiti'
  },
  {
    src: 'https://cloud.sharemyimage.com/2026/10/08/Binjamin_BW_1.png',
    alt: 'Black and white Binjamin sketch illustration',
    book: 'binjamin',
    label: 'Classic Inking'
  }
];

export default function ArtworkGallery() {
  const [filter, setFilter] = useState('all');

  const filteredItems = filter === 'all'
    ? galleryItems
    : galleryItems.filter((item) => item.book === filter);

  return (
    <div className="artwork-gallery-container">
      <div className="gallery-filter-bar">
        <button
          type="button"
          className={`gallery-filter-btn ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          <SafeIcon icon={FiImage} /> All Illustrations ({galleryItems.length})
        </button>
        <button
          type="button"
          className={`gallery-filter-btn ${filter === 'pepito' ? 'active' : ''}`}
          onClick={() => setFilter('pepito')}
        >
          🦀 Pepito the Hermit Crab
        </button>
        <button
          type="button"
          className={`gallery-filter-btn ${filter === 'binjamin' ? 'active' : ''}`}
          onClick={() => setFilter('binjamin')}
        >
          🗑️ Binjamin the Dumpster
        </button>
      </div>

      <div className="dynamic-gallery-grid">
        {filteredItems.map((item) => (
          <motion.div
            layout
            key={item.src}
            className={`gallery-frame ${item.book === 'pepito' ? 'pepito-frame' : 'binjamin-frame'}`}
            whileHover={{ y: -6, scale: 1.02 }}
            transition={{ duration: 0.2 }}
          >
            <div className="gallery-frame-inner">
              <img src={item.src} alt={item.alt} loading="lazy" />
            </div>
            <div className="gallery-frame-caption">
              <span>{item.label}</span>
              <span className="gallery-tag-pill">{item.book === 'pepito' ? 'Pepito' : 'Binjamin'}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
